import ajax from './ajax'
const BASE_URL = '//www.37games.com/ajax/';

// error
// https://www.37games.com/musjp/ajax/get_game_info?gameID=251

// 文档错误，现在不需要加游戏简码，gameID不可缺
// https://www.blancozone.com/ajax/get_game_info?gameID=251

export const getGameInfo = ({ success, fail }) => {
  ajax.request({
    url: BASE_URL + 'get_game_info?gameID=255',
  }).then((res) => {
    // console.log(res);
    res.result == 1 ?
      success(res.data) :
      fail && fail(res.data);
  }).catch((err) => {
    fail && fail(err);
    // console.log(err);
  })
}

export const getArticleList = ({ success, fail }) => {
  ajax.request({
    url: BASE_URL + 'article_list?ids=1157,1158,1159&gameID=255&orderBy=PUBLISH_TIME&orderWay=DESC'
  }).then((res) => {
    // console.log(res);
    res.result == 1 ?
      success(res.data) :
      fail && fail(res.data);
  }).catch((err) => {
    fail && fail(err);
    // console.log(err);
  })
}

export const getSliderList = ({ success, fail }) => {
  ajax.request({
    url: BASE_URL + 'article_slide_list?gameID=255&site=main&orderBy=RANK&orderWay=DESC'
  }).then((res) => {
    // console.log(res);
    res.result == 1 ?
      success(res.data) :
      fail && fail(res.data);
  }).catch((err) => {
    fail && fail(err);
    // console.log(err);
  })
}

